import { SkeletonTable } from '../../../components/Skeleton';
import Pagination from '../../../components/Pagination/Pagination';
import { useQueryClient } from '@tanstack/react-query';

import { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { useChargingHistorySimple } from '../../../hooks/useChargingHistorySimple';

// 시간 차이를 HH:mm:ss 형식으로 변환
const formatDuration = (startTime, endTime) => {
  if (!startTime || !endTime) return '-';
  
  const diffInSeconds = dayjs(endTime).diff(dayjs(startTime), 'seconds');
  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;
  
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const ChargingHistory = ({chargerSysId}) => {
  const currentPage = 1;
  const pageSize = 10;
  const searchQuery = '';
  const sortBy = 'StartTime';
  const sortOrder = 'desc';
  
  const today = dayjs().format('YYYY-MM-DD');
  const monthAgo = dayjs().subtract(1, 'month').format('YYYY-MM-DD');

  const [startTime, setStartTime] = useState(monthAgo);
  const [endTime, setEndTime] = useState(today);
  const [cpoStationId, setCpoStationId] = useState("");
  const [cpoChargerId, setCpoChargerId] = useState("");
  
  const queryClient = useQueryClient();

  // 쿼리 파라미터 메모이제이션 (URL 상태와 연동)
  const queryParams = useMemo(() => ({
    Page: currentPage,
    PageSize: pageSize,
    ChargerSysId: chargerSysId,
    StartTime: startTime,
    EndTime: endTime,
    OrderBy: sortBy,
    OrderDirection: sortOrder,
    // CpoStationId: cpoStationId,
    // CpoChargerId: cpoChargerId,
  }), [chargerSysId, startTime, endTime, cpoStationId, cpoChargerId]);

  const {
    chargingHistory,
    isLoading,
    error,
    totalCount,
  } = useChargingHistorySimple(queryParams);
  

  return (
    <div>

        <div className="primary-table">
          {isLoading && (
            <SkeletonTable rows={8} columns={8} />
          )}
          {error && (
            <div className="error-container">
              <p>데이터를 불러오는데 실패했습니다: {error.message}</p>
              <button onClick={() => window.location.reload()} className="btn btn-primary">다시 시도</button>
            </div>
          )}
          {!isLoading && !error && (
            <>
              <table>
                <thead>
                  <tr>
                    <th>충전 시작 일시</th>
                    <th>충전 종료 일시</th>
                    <th>충전 시간</th>
                    <th>충전량 (kWh)</th>
                  </tr>
                </thead>
                <tbody>
                  {chargingHistory.map(history => (
                    <tr key={history.ChargingHistorySysId}>
                      <td>{dayjs(history.StartTime).format('YYYY-MM-DD HH:mm:ss')}</td>
                      <td>{dayjs(history.EndTime).format('YYYY-MM-DD HH:mm:ss')}</td>
                      <td>{formatDuration(history.StartTime, history.EndTime)}</td>
                      <td>{(history.AoC/1000).toFixed(2)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        )}
        </div>
        <div className='pagination-wrapper'>
          <Pagination totalCount={totalCount} pageSize={10} currentPage={1} onPageChange={() => {}} />
        </div>
    </div>
  )
}

export default ChargingHistory